import React from 'react';

const EmpresaEstrangeiraContext = React.createContext();

export default EmpresaEstrangeiraContext;
